import React from "react";

const TONE_PATTERN = /[\u0300\u0301]/g
const TONE_CLASS = {
    "\u0300": "token-glyph__tone--grave",
    "\u0301": "token-glyph__tone--acute",
}

const TokenGlyph = ({ token, uppercase = false }) => {
    const display = uppercase ? (token || "").toUpperCase() : (token || "")
    const decomposed = display.normalize("NFD")
    const toneMatch = decomposed.match(TONE_PATTERN)

    if (!toneMatch) {
        return <span className="token-glyph">{display.normalize("NFC")}</span>
    }

    const base = decomposed.replace(TONE_PATTERN, "").normalize("NFC")
    const tone = toneMatch[toneMatch.length - 1]

    return (
        <span className="token-glyph token-glyph--toned" aria-label={display.normalize("NFC")}>
            <span className="token-glyph__base" aria-hidden="true">{base}</span>
            <span className={`token-glyph__tone ${TONE_CLASS[tone]}`} aria-hidden="true" />
        </span>
    )
}

export default TokenGlyph;
